import { render } from "./ReviewAdmin.vue?vue&type=template&id=3b6b0398"
import script from "./ReviewAdmin.vue?vue&type=script&lang=js"
export * from "./ReviewAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__